import { Text, type TextProps } from '@mantine/core'
import React from 'react'

import { useCurrencyUtils } from '@flecto/utils'

export type TextCurrencyProps = TextProps & {
  cents: number
}

export function TextCurrency({ cents, ...props }: TextCurrencyProps) {
  const { centsToCurrency } = useCurrencyUtils()

  return <Text {...props}>{centsToCurrency(cents, true)}</Text>
}
